"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_PAYMENT_METHOD = void 0;
exports.CREDIT_BUILDER_PAYMENT_METHOD = {
    SECTION_HEADER: 'Available funds',
    CTA: 'Withdraw'
};
